import type {
  ReferentialAssetEventSubtype,
  ReferentialAssetEventType,
} from "./referential-asset-event-types.type";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential, REFERENTIAL_NAMES } from "@/entities/referential";

export const useReferentialAssetEventTypes = (
  options?: UseReferentialOptions<ReferentialAssetEventType[]>
) => {
  const { data: assetEventTypes = [], ...result } = useReferential<
    ReferentialAssetEventType[]
  >(REFERENTIAL_NAMES.ASSET_EVENT_TYPES, options);

  const getAssetEventSubTypes = (
    type?: string
  ): ReferentialAssetEventSubtype[] => {
    return (
      assetEventTypes.find((eventType) => eventType.slug === type)?.subtypes ??
      []
    );
  };

  return {
    ...result,
    assetEventTypes,
    getAssetEventSubTypes,
  };
};
